import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { StudentSignPhotoUploadPopupComponent } from '../student-sign-photo-upload-popup/student-sign-photo-upload-popup.component';
import { MatDialog } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { PageEvent } from '@angular/material/paginator';
import { HttpErrorResponse } from '@angular/common/http';
@Component({
  selector: 'app-student-sign-photo-upload',
  templateUrl: './student-sign-photo-upload.component.html',
  styleUrls: ['./student-sign-photo-upload.component.scss']
})
export class StudentSignPhotoUploadComponent implements OnInit {
  studentDataForm: FormGroup;
  studentDataList: any;
  CourseList: any;
  filteredListCourse: any;
  examList: any[] = [];
  filteredListExam: any[] = [];

  constructor(
    private dialog: MatDialog,
    private fb: FormBuilder,
    private modalPopupService: ModalpopService,
    public umsService: UmsService,
    private spinner: NgxSpinnerService
  ) { }

  userPermission: any;
  UserCollege: any; 
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 20];
  currentPage = 1;
  totalItems = 0;

  ngOnInit(): void {
    this.userPermission = JSON.parse(sessionStorage.getItem('userPermission'));
    this.studentDataForm = this.fb.group({
      CoCode: new FormControl(''),
      SearchString: new FormControl(''),
      exam: new FormControl(0) 
    });
    this.getstudentdata();
    this.fetchCourse();
  }
  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    const newPageIndex = event.pageIndex + 1;
    this.currentPage = newPageIndex;
    this.getstudentdata();
  }

  updatePhotoSign(student: any, value: string) {
    const dialogRef = this.dialog.open(StudentSignPhotoUploadPopupComponent, {
      width: '100%',
      data: {
        selected: student,
        key: value
      },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {});
  }

  fetchCourse() {
    const payload = {};
    this.spinner.show();
    this.umsService.getCourse(payload).subscribe(res => {
      if (res.status) {
        this.CourseList = res.data;
        this.filteredListCourse = this.CourseList.slice();
        this.spinner.hide();
      } else {
        this.spinner.hide();
      }
    });
  }

  getExamList(courseCode: number) {
    if (!courseCode) {
      this.examList = [];
      this.filteredListExam = [];
      this.studentDataForm.patchValue({ exam: 0 });
      return;
    }
    this.spinner.show();
    this.studentDataForm.patchValue({ exam: 0 });
    this.examList = [];
    this.filteredListExam = [];

    const payload = { EmCoCode: courseCode };
    this.umsService.getExam(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        const allOption = { EmId: 0, EmName: 'ALL', EmCoCode: '' };
        this.examList = [allOption, ...res.data];
        this.filteredListExam = this.examList.slice();
        this.studentDataForm.patchValue({ exam: 0 });
      }
    }, () => {
      this.spinner.hide();
      this.examList = [];
    });
  }
  getstudentdata() {
    if (this.userPermission[0]?.CgUi == 'C') {
      this.UserCollege = this.userPermission[0].CgId;
    } else {
      this.UserCollege = '';
    }
    this.spinner.show();
    const examValue = this.studentDataForm.value.exam;
    const emId = (examValue === '' || examValue == null) ? '' : examValue;

    const payload: any = {
      PageSize: this.pageSize,
      PageNumber: this.currentPage,
      CgCode: this.UserCollege,
      CoCode: this.studentDataForm.value.CoCode || '',
      EmId: emId,
      SearchString: this.studentDataForm.value.SearchString || ''
    };
    this.umsService.collegewisestudentData(payload).subscribe(
      (res) => {
        this.spinner.hide();
        if (res.status) {
          this.studentDataList = res.data;
          this.totalItems = res.data[0]?.TotalRecords || 0;
        } else {
          this.studentDataList = [];
          this.totalItems = 0;
        }
      },
      (error) => {
        this.spinner.hide();
        this.studentDataList = [];
        this.totalItems = 0;
      }
    );
  }
  onSearchEnter(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.currentPage = 1;
      this.getstudentdata();
      event.preventDefault();
    }
  }
  clearSearch() {
    this.studentDataForm.get('SearchString').setValue('');
    this.currentPage = 1;
    this.getstudentdata();
  }
}